import { QRCodeCanvas } from "qrcode.react";
import "./QRCode.css";

const QRCodePage = () => {
  const url = "https://yourwebsite.com";

  return (
    <div className="qr-container">
      <QRCodeCanvas value={url} size={400} />
    </div>
  );
};

export default QRCodePage;
